import React from 'react';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  className?: string;
}
export default function Ouvrir(props: Props) {
  return (
    <svg
      className={props.className}
      width={props.width ? props.width + 'px' : '24px'}
      height="12px"
      viewBox="0 0 24 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Ouvrir</title>
      <g id="BOARD-3---Icônes" transform="translate(-638.000000, -292.000000)" fill="#1B202D">
        <g id="Pictogrammes" transform="translate(305.000000, 178.000000)">
          <g id="12---Ouvrir" transform="translate(333.000000, 103.000000)">
            <path
              d="M12.6585938,22.7468221 L23.7285998,12.469726 C24.0910829,12.1329656 24.0904735,11.5878129 23.7267248,11.2517034 C23.363023,10.9157674 22.7738533,10.9166354 22.4110891,11.2534392 L11.9999557,20.9188117 L1.58886913,11.2530487 C1.22605797,10.916375 0.63726327,10.9155071 0.273514614,11.2513128 C0.0911715381,11.4198666 0,11.640627 0,11.8613873 C0,12.0815835 0.0905621653,12.301476 0.271639621,12.4696826 L11.3413643,22.7468221 C11.5156449,22.9089532 11.7528316,23 11.9999557,23 C12.2470797,23 12.4839382,22.9086928 12.6585938,22.7468221"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
